import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios, { CancelToken } from 'axios';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { invitationService } from '@api/services/services';
import { QcsAutocompleteWithoutFormik } from '../../../common/form/QcsAutocompleteWithoutFormik';
import { getLangNameObj } from '../../../../utils/format';
import { useInvitation } from './invitationFunctions';

interface Props {
  value?: ReferenceDto;
  onChange: (value?: ReferenceDto) => void;
}

export const GridFilterLogActionBy: FC<Props> = ({ value, onChange }) => {
  const { i18n } = useTranslation();
  const { invitation } = useInvitation();
  const [options, setOptions] = useState<ReferenceDto[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(false);

  const loadOptions = useCallback(
    (_search: string | undefined, cancelToken: CancelToken) => {
      setLoading(true);
      setLoadingError(false);

      invitationService
        .getInvitationHistoryPersons(invitation.id!, { cancelToken })
        .then((response) => {
          setOptions(response.data);
          setLoading(false);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            setLoadingError(true);
            setLoading(false);
          }
        });
    },
    [invitation.id],
  );

  const handleChange = (val?: ReferenceDto | ReferenceDto[] | null) => {
    onChange((val as ReferenceDto) ?? undefined);
  };

  return (
    <QcsAutocompleteWithoutFormik
      options={options}
      loading={loading}
      loadingError={loadingError}
      loadOptions={loadOptions}
      value={value ?? undefined}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={(option: ReferenceDto) => getLangNameObj(i18n, option)}
      onChange={handleChange}
    />
  );
};
